import EmailConfirmationPage from './EmailConfirmationPage';
export { EmailConfirmationPage };



// WEBPACK FOOTER //
// ./src/modules/email-confirmation/index.js